"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { FeatureRowProps } from "./FeatureRow";
import { Icon } from "@/components/formatters/MXPIcon";
import { FeatureCellMobile } from "./FeatureCellMobile";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
type FeatureRowMobileProps = {
  feature: FeatureRowProps;
  selectedIndexes: number[];
};
const headerTextClasses = "text-gray-m10 text-lg not-italic font-normal leading-8 tracking-[0.18px] bg-transparent border-none text-left p-0 cursor-pointer max-sm:text-base max-sm:leading-[1.375rem]";
const FeatureRowMobile = t0 => {
  const $ = _c(15);
  const {
    feature,
    selectedIndexes
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const hasDescription = !!feature.description;
  let t1;
  if ($[0] !== feature.description || $[1] !== feature.title || $[2] !== hasDescription || $[3] !== isOpen) {
    t1 = hasDescription ? <button className="w-full max-w-[470px] bg-transparent border-none cursor-pointer text-left" onClick={() => setIsOpen(_temp)} aria-expanded={isOpen}><div className="flex items-center gap-2 px-6"><Icon type="t2u-chevron-right" rotateDeg={isOpen ? "270" : "90"} size={12} className="transition-transform duration-200 ease-in-out" /><h3 className={headerTextClasses}>{feature.title}</h3></div>{isOpen && <CommonDescription description={feature.description} className="text-[#464b52] text-base not-italic font-normal leading-6 tracking-[0.16px] bg-transparent border-none text-left px-[46px] mt-2 [&_a]:text-blue-trmb [&_a]:underline t2-layout__description" />}</button> : <div className="w-full max-w-[470px]"><div className="flex items-center gap-2 px-6"><h3 className={headerTextClasses}>{feature.title}</h3></div></div>;
    $[0] = feature.description;
    $[1] = feature.title;
    $[2] = hasDescription;
    $[3] = isOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== feature.productFeatureValues || $[6] !== selectedIndexes) {
    let t3;
    if ($[8] !== feature.productFeatureValues) {
      t3 = (productIndex, index) => {
        const val = productIndex >= 0 ? feature.productFeatureValues[productIndex] : undefined;
        return val ? <FeatureCellMobile key={`feature-cell-${index}`} value={val} /> : <div key={`feature-cell-${index}`} className="min-h-8 w-full max-w-[131px]" />;
      };
      $[8] = feature.productFeatureValues;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = selectedIndexes.map(t3);
    $[5] = feature.productFeatureValues;
    $[6] = selectedIndexes;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <div className="flex mt-6 justify-around text-center">{t2}</div>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <div className="border border-gray-m2 border-b-0 py-3 first:border-t-0 last:border-b-0">{t1}{t3}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default FeatureRowMobile;
function _temp(prev) {
  return !prev;
}